import React, { memo } from 'react';
import isString from 'lodash/isString';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { ContainerStyled } from './Header.styled';
const getHeaderElement = (headerPart) => isString(headerPart) ? (React.createElement(RegularTextLevel3, { weight: 500 }, headerPart)) : (headerPart);
export const Header = memo(({ headerLeft, headerRight, isRightToLeft = false }) => {
    const HeaderLeft = getHeaderElement(headerLeft);
    const HeaderRight = getHeaderElement(headerRight);
    return (React.createElement(ContainerStyled, { isRightToLeft: isRightToLeft },
        HeaderLeft,
        HeaderRight));
});
Header.displayName = 'BottomSheetHeader';
